import { ConfigProvider, Modal } from "antd";
import zhCN from "antd/lib/locale/zh_CN";
import classNames from "classnames";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

/**
 * @typedef {import("antd").ModalProps} ModalProps
 * @typedef  {ITrackProps & ModalProps & {
 *  children?: React.ReactNode
 *  closeAttrs?: React.HTMLAttributes<HTMLDivElement>
 *  onCancel?: (e?: any)=>void
 *  onOk?: (param?: any)=>void
 *  styleMode?: 'dark' | 'light'
 * }} HBModalProps
 * @param {HBModalProps} props
 * @returns
 */
export default function HBModal(props) {
  return (
    <ConfigProvider autoInsertSpaceInButton={false} locale={zhCN}>
      <Modal
        cancelButtonProps={{ type: "text" }}
        closeIcon={<HBIcon {...(props.closeAttrs || {})} type="ic_close" />}
        centered
        {...props}
        wrapClassName={classNames(
          styles.modal,
          props.styleMode === "dark" && styles.darkModal,
          props.wrapClassName
        )}
      />
    </ConfigProvider>
  );
}
